// plugins/socket.js
import socketService from "@/socket";

export default {
  install(Vue) {
    Vue.prototype.$socket = {
      connect: socketService.connect,
      disconnect: socketService.disconnect,
      getSocket: socketService.getSocket,
    };
  },
};
